import Image from "next/image";
import React, {useEffect, useState} from "react";
import {Card, CardBody, ScrollShadow} from "@nextui-org/react";

import sharedService from "@/services/shared-service";
import imgStatic from '../../public/webp/chanh-toa.webp'
import {getDeaneries} from "@/services/home-service";

export default function DeaneryBlock({params, actions}) {
    const [deaneries, setDeaneries] = useState({total: 0});

    const fetchData = async () => {
        const response = await getDeaneries(params);

        setDeaneries(response);
        
        if (response.pageData?.pageCount > 0) {
            let deaneryArr = [];
            response.value.map((deaneryItem) => {
                deaneryArr.push({
                    value: deaneryItem.id,
                    label: deaneryItem.name,
                });
            });

            actions.setDeaneriesData(deaneryArr);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const deaneriesElement = <>
        {deaneries.pageData?.pageCount > 0 && deaneries.value.map((deanery, index) => {
            let isCurrentDeanery = params.currentDeanery === deanery.id;

            return <>
                <Card key={index} isBlurred shadow="sm" isPressable
                      onPress={() => {
                          actions.setCurrentPage(1)
                          actions.setCurrentDeanery(deanery.id);

                          let currentDeanery = isCurrentDeanery ? '' : deanery.id;
                          actions.setCurrentDeanery(currentDeanery);
                      }}
                      className="border-none bg-background/60 dark:bg-default-100/50 max-w-[610px] my-3 md:m-0 mx-auto"
                >
                    <CardBody
                        className={`bg-${isCurrentDeanery ? 'primary' : 'secondary'} py-3 border-1 border-solid border-primary rounded-[inherit]`}>
                        <div className="grid grid-cols-3 gap-10 items-center justify-center">
                            <div className="relative">
                                <Image
                                    alt={deanery?.name} width={100} height={100}
                                    className="rounded-none w-[350px] sm:w-[296px] h-[5.5rem] object-cover"
                                    src={deanery.photoUrl ? sharedService.getOptimizeImage(deanery.photoUrl, 'small-post-view') : imgStatic}
                                />
                            </div>

                            <div
                                className={`col-span-2 flex flex-col text-${isCurrentDeanery ? 'white' : 'primary'} font-bold text-xl`}>
                                GIÁO HẠT {deanery?.name.toUpperCase()}
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </>
        })}
    </>

    return <>
        <div>
            {/* Desktop */}
            <div className="md:grid gap-3 md:grid-cols-3 hidden">
                {deaneriesElement}
            </div>

            {/* Mobile */}
            <div className="grid gap-3">
                <ScrollShadow hideScrollBar className="w-full h-[300px] md:hidden">
                    {deaneriesElement}
                </ScrollShadow>
            </div>
        </div>
    </>
}
